"use client"

import { useEffect, useState } from "react"
import { getTeamLogoWithFallback } from "../utils/teamLogoUtils"

function SportsEvent({ event, onSelect }) {
  const [eventImage, setEventImage] = useState("sports_video.png")

  useEffect(() => {
    getImageFileNameByTitle(event.sport_title)
  }, [])

  const handleSelect = (team) => {
    console.log("team, ", team)

    onSelect({
      ...event,
      user_pick: team,
    })
  }

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString)
      return {
        day: date.toLocaleDateString("en-US", {
          weekday: "short",
        }),
        month: date.toLocaleDateString("en-US", {
          month: "short",
        }),
        dayNum: date.toLocaleDateString("en-US", {
          day: "2-digit",
        }),
        year: date.getFullYear(),
        time: date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        }),
        timezone: "CDT",
      }
    } catch (error) {
      return {
        day: "Invalid",
        month: "Invalid",
        dayNum: "XX",
        year: "XXXX",
        time: "12:00PM",
        timezone: "CDT",
      }
    }
  }
  const formattedDate = formatDate(event.commence_time)
  const homeLogo = getTeamLogoWithFallback(event.home_team, event.sport_key)
  const awayLogo = getTeamLogoWithFallback(event.away_team, event.sport_key)

  function getImageFileNameByTitle(title) {
    // Find the sport object that matches the title
    const sports = [
      { title: "MLB", icon: "sports_soccer.png" },
      { title: "NBA", icon: "sports_basketball.png" },
      { title: "NCAAB", icon: "sports_basketball.png" },
      { title: "Boxing", icon: "sports_mma.png" },
      { title: "NFL", icon: "sports_football-1.png" },
      { title: "NCAAF", icon: "sports_football-1.png" },
      { title: "Golf", icon: "sports_tennis.png" },
      { title: "MMA", icon: "sports_martial_arts.png" },
      { title: "Tennis", icon: "sports_tennis.png" },
    ]

    const sport = sports.find((item) => item.title === title)

    // If a match is found, extract the file name from the src path
    if (sport) {
      setEventImage(sport.icon)
      return sport.icon
    }

    // Return null if no match is found
    return "sports_video.png"
  }

  return (
    <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl overflow-hidden mb-4 font-medium text-white border border-gray-700 hover:border-emerald-500/30 transition-all duration-300">
      {/* Header */}
      <div className="grid grid-cols-3 items-center p-4 border-b border-gray-700/50">
        <div className="flex items-center">
          <span className="text-white text-sm font-medium pr-2">{event.sport_title}</span>
          <div className="bg-emerald-500/20 p-1.5 rounded-lg">
            <img
              className="w-[18px]"
              alt="sportslogo"
              src={require(`../assets/MenuImages/${eventImage || "/placeholder.svg"}`)}
            />
          </div>
        </div>
        <div className="text-white text-xs md:text-sm text-center">
          {formattedDate.day} {formattedDate.month} {formattedDate.dayNum} {formattedDate.year}
        </div>
        <div className="text-right">
          <span className="text-white text-sm font-medium">
            {formattedDate.time} {formattedDate.timezone}
          </span>
        </div>
      </div>

      {/* Home Team */}
      <div className="grid grid-cols-3 items-center border-b border-gray-700/30 py-4 font-medium text-white">
        <div className="flex items-center p-3">
          <div className="w-1 h-4 bg-green-500 rounded-full mr-2"></div>
          <span className="text-white text-sm">Home</span>
        </div>
        <div className="text-center">
          <div className="inline-flex items-center justify-center gap-2 max-w-full">
            <img
              src={homeLogo}
              alt={event.home_team}
              className="w-5 h-5 rounded-full bg-gray-900/60 border border-gray-700 object-contain p-0.5 shrink-0"
              onError={(e) => {
                e.currentTarget.onerror = null
                e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(event.home_team)}&background=1f2937&color=ffffff&size=96`
              }}
            />
            <span className="text-white text-sm truncate">{event.home_team}</span>
          </div>
        </div>
        <div className="flex justify-end p-3">
          <button
            onClick={() => handleSelect(event.home_team)}
            className="bg-emerald-500 hover:bg-emerald-600 text-white py-1.5 rounded-full px-5 text-sm transition-colors"
          >
            Select
          </button>
        </div>
      </div>

      {/* Away Team */}
      <div className="grid grid-cols-3 items-center py-4 font-medium text-white">
        <div className="flex items-center p-3">
          <div className="w-1 h-4 bg-blue-400 rounded-full mr-2"></div>
          <span className="text-white text-sm">Away</span>
        </div>
        <div className="text-center">
          <div className="inline-flex items-center justify-center gap-2 max-w-full">
            <img
              src={awayLogo}
              alt={event.away_team}
              className="w-5 h-5 rounded-full bg-gray-900/60 border border-gray-700 object-contain p-0.5 shrink-0"
              onError={(e) => {
                e.currentTarget.onerror = null
                e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(event.away_team)}&background=1f2937&color=ffffff&size=96`
              }}
            />
            <span className="text-white text-sm truncate">{event.away_team}</span>
          </div>
        </div>
        <div className="flex justify-end p-3">
          <button
            onClick={() => handleSelect(event.away_team)}
            className="bg-emerald-500 hover:bg-emerald-600 text-white py-1.5 rounded-full px-5 text-sm transition-colors"
          >
            Select
          </button>
        </div>
      </div>
    </div>
  )
}

export default SportsEvent

